import{config}from"../config";export var isProduction=function isProduction(){return config.env==='prod';};